/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetApiEmployeesQueryResponse,
  GetApiEmployeesQueryParams,
} from '../models/GetApiEmployees.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getApiEmployeesQueryResponseSchema } from '../zod/getApiEmployeesSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getApiEmployeesQueryKey = (params: GetApiEmployeesQueryParams) =>
  [{ url: '/api/employees' }, ...(params ? [params] : [])] as const;

export type GetApiEmployeesQueryKey = ReturnType<
  typeof getApiEmployeesQueryKey
>;

/**
 * {@link /api/employees}
 */
export async function getApiEmployees(
  params: GetApiEmployeesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiEmployeesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/employees`,
    params,
    ...requestConfig,
  });
  return getApiEmployeesQueryResponseSchema.parse(res.data);
}

export function getApiEmployeesQueryOptions(
  params: GetApiEmployeesQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getApiEmployeesQueryKey(params);
  return queryOptions<
    GetApiEmployeesQueryResponse,
    ResponseErrorConfig<Error>,
    GetApiEmployeesQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getApiEmployees(params, config);
    },
  });
}

/**
 * {@link /api/employees}
 */
export function useGetApiEmployees<
  TData = GetApiEmployeesQueryResponse,
  TQueryData = GetApiEmployeesQueryResponse,
  TQueryKey extends QueryKey = GetApiEmployeesQueryKey,
>(
  params: GetApiEmployeesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiEmployeesQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getApiEmployeesQueryKey(params);

  const query = useQuery(
    {
      ...getApiEmployeesQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
